import { get, put } from './Common';
import { 
    CreateBooking, 
    CancelBooking, 
    MakeBookingOffer, 
    DeclineBooking, 
    AcceptBookingOffers, 
    RejectBookingOffer, 
    WithdrawBookingOffer,
    PayForBooking,
    SaveOfferSettings,
    CreateBookingResult,
    GetBooking,
    GetBookingResult,
    ImportBooking,
    AddInvoice,
    MarkInvoicePaid,
    SendBookingMessage,
    SaveSession,
    MoveSessions,
    SaveColorSettings,
    SaveCalendarSettings,
    GetInstructorProfile,
    GetInstructorProfileResult,
    AddInstructorExperience,
    AddInstructorCertifications,
    GiveInstructorKudos,
    VerifyInstructorExperience,
    OfferInstructorJob,
    InviteInstructor,
    GetInstantBookingSettings,
    GetInstantBookingSettingsResult,
    CreateInstantBooking
} from './Commands';

export const hello = async () => {
    return await get('hello');
};

export const createBooking = async (command: CreateBooking) => {
    const result = await put('public/createBooking', command);
    return result as CreateBookingResult;
};

export const createInstantBooking = async (command: CreateInstantBooking) => {
    const result = await put('public/createInstantBooking', command);
    return result as CreateBookingResult;
};

export const getBooking = async (command: GetBooking) => {
    const result = await get('public/getBooking', command);
    return result as GetBookingResult;
};

export const cancelBooking = async (command: CancelBooking) => {
    return await put('cancelBooking', command);
};

export const declineBooking = async (command: DeclineBooking) => {
    return await put('declineBooking', command);
};

export const makeOffer = async (command: MakeBookingOffer) => {
    return await put('makeOffer', command);
};

export const acceptOffers = async (command: AcceptBookingOffers) => {
    return await put('acceptOffers', command);
};

export const rejectOffer = async (command: RejectBookingOffer) => {
    return await put('rejectOffer', command);
};

export const withdrawOffer = async (command: WithdrawBookingOffer) => {
    return await put('withdrawOffer', command);
};

export const payForBooking = async (command: PayForBooking) => {
    return await put('payForBooking', command);
};

export const saveOfferSettings = async (command: SaveOfferSettings) => {
    return await put('saveOfferSettings', command);
};

export const getInstantBookingSettings = async (command: GetInstantBookingSettings) => {
    const result = await get('public/getInstantBookingSettings', command);
    return result as GetInstantBookingSettingsResult;
};

export const saveColorSettings = async (command: SaveColorSettings) => {
    return await put('saveColorSettings', command);
};

export const saveCalendarSettings = async (command: SaveCalendarSettings) => {
    return await put('saveCalendarSettings', command);
};

export const importBooking = async (command: ImportBooking) => {
    return await put('importBooking', command);
};

export const addInvoice = async (command: AddInvoice) => {
    return await put('addInvoice', command);
};

export const markInvoicePaid = async (command: MarkInvoicePaid) => {
    return await put('markInvoicePaid', command);
};

export const sendBookingMessage = async (command: SendBookingMessage) => {
    return await put('sendBookingMessage', command);
};

export const createSession = async (command: SaveSession) => {
    return await put('createSession', command);
};

export const updateSession = async (command: SaveSession) => {
    return await put('updateSession', command);
};

export const moveSessions = async (command: MoveSessions) => {
    return await put('moveSessions', command);
};

export const getInstructorProfile = async (command: GetInstructorProfile) => {
    const result = await get('public/getInstructorProfile', command);
    return result as GetInstructorProfileResult;
};

export const addInstructorExperience = async (command: AddInstructorExperience) => {
    return await put('addInstructorExperience', command);
};

export const addInstructorCertifications = async (command: AddInstructorCertifications) => {
    return await put('addInstructorCertifications', command);
};

export const giveInstructorKudos = async (command: GiveInstructorKudos) => {
    return await put('giveInstructorKudos', command);
};

export const offerInstructorJob = async (command: OfferInstructorJob) => {
    return await put('offerInstructorJob', command);
};

export const inviteInstructor = async (command: InviteInstructor) => {
    return await put('inviteInstructor', command);
};

export const verifyInstructorExperience = async (command: VerifyInstructorExperience) => {
    return await put('verifyInstructorExperience', command);
};